







import Vue from 'vue';
import { Avatar } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Avatar },
  props: {
    email: {
      type: String,
      default: '',
    },
  },
});
